import React, { useEffect, useMemo, useState } from "react";
import ReusableTable from "../../components/Employee/Table";
import "./BusinessListLayout.css";
import { useGetAllOBPaginated } from "../../hooks/useAttendance";
import { formatDateOnly, getMediaBase64 } from "../../util/common";
import { useNavigate } from "react-router-dom";

export default function BusinessListLayout() {
  const [pageCount, setPageCount] = useState(1);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 20,
  });

  const [filter, setFilter] = useState({
    ApprovalStatus: null,
    OrderBy: "desc",
  });

  const [obRecords, setOBRecords] = useState([]);

  const obRequests = useGetAllOBPaginated();

  const fetchOBRequestsRecords = async () => {
    obRequests.mutate(
      {
        page: pagination.page,
        pageSize: pagination.pageSize,
        filters: filter,
      },
      {
        onSuccess: async (result) => {
          if (!result.success) return;

          const records = await Promise.all(
            result.data.data.map(async (record) => {
              return {
                RequestCode: record.RequestCode,
                OBDateFrom: formatDateOnly(record.OBDateFrom),
                OBDateTo: formatDateOnly(record.OBDateTo),
                OBTimeFrom: record.OBTimeFrom,
                OBTimeTo: record.OBTimeTo,
                Reason: record.Reason,
                Media: await getMediaBase64(record?.Media?.MediaUrl),
                ApproverEmployee: record.ApproverEmployee?.FullName,
                ApprovedAt: formatDateOnly(record.ApprovedAt),
                RejectedAt: formatDateOnly(record.RejectedAt),
                RejectReason: record.RejectReason,
                ApprovalStatus: record.ApprovalStatus,
              };
            })
          );

          setOBRecords(records);
          setPageCount(result.data.pagination.totalPages);
        },
      }
    );
  };

  useEffect(() => {
    fetchOBRequestsRecords();
  }, [pagination, filter]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "RequestCode",
        header: "Request Code",
      },
      {
        accessorKey: "OBDateFrom",
        header: "Date From",
      },
      {
        accessorKey: "OBDateTo",
        header: "Date To",
      },
      {
        accessorKey: "OBTimeFrom",
        header: "Time From",
      },
      {
        accessorKey: "OBTimeTo",
        header: "Time To",
      },
      {
        accessorKey: "Reason",
        header: "Reason",
      },
      {
        accessorKey: "Media",
        header: "Media",
        cell: ({ getValue }) => {
          const url = getValue();
          if (!url) return "No Image";
          return (
            <img
              src={url}
              alt="Media"
              style={{
                width: "60px",
                height: "60px",
                objectFit: "cover",
                borderRadius: "6px",
              }}
            />
          );
        },
      },
      {
        accessorKey: "ApproverEmployee",
        header: "Approver Name",
      },
      {
        accessorKey: "ApprovedAt",
        header: "Approved At",
      },
      {
        accessorKey: "RejectedAt",
        header: "Rejected At",
      },
      {
        accessorKey: "RejectReason",
        header: "Reject Reason",
      },
      {
        accessorKey: "ApprovalStatus",
        header: "Status",
        cell: ({ row }) => {
          console.log("ROW: ", row);
          const status = row.original.ApprovalStatus;
          return (
            <span className={`status-badge status-${status.toLowerCase()}`}>
              {status}
            </span>
          );
        },
      },
    ],
    []
  );

  const handleOnPageChange = (pageIndex, pageSize) => {
    setPagination({
      page: pageIndex + 1,
      pageSize,
    });
  };

  const navigate = useNavigate();

  return (
    <div className="official-business-container">
      <div className="header-row">
        <h3>Official Business Records</h3>

        <div className="filters-right">
          <button
            className="add-business-btn"
            onClick={() => navigate("/BusinessApplication")}
          >
            + Official Business
          </button>

          <select
            value={filter.ApprovalStatus}
            className="status-filter"
            onChange={(e) => {
              setFilter({
                ApprovalStatus: e.target.value,
                OrderBy: filter.OrderBy,
              });
            }}
          >
            <option value="">All Status</option>
            <option value="Approved">Approved</option>
            <option value="Pending">Pending</option>
            <option value="Cancelled">Cancelled</option>
            <option value="Rejected">Rejected</option>
          </select>
        </div>
      </div>

      <ReusableTable
        data={obRecords}
        columns={columns}
        mode="server"
        initialPageSize={pagination.pageSize}
        onPageChange={handleOnPageChange}
        pageCount={pageCount}
        page={pagination.page - 1}
        pageSize={pagination.pageSize}
      />
    </div>
  );
}
